import { useTheme } from "@mui/material";

export function ZohoCredentialsModal({ zohoClientId, setZohoClientId, zohoClientSecret, setZohoClientSecret, errorMessage }) {
  const theme = useTheme();
  return (
    <div className="flex flex-col px-5 sm:px-14 pt-8 py-10 gap-5">
      <div className="flex flex-col gap-3">
        <label className="font-bold">Client ID</label>
        <input
          type="text"
          value={zohoClientId}
          onChange={(e) => setZohoClientId(e.target.value)}
          placeholder="Enter the client ID"
          className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          style={{
            borderColor: theme.palette.secondary.v4,
            color: theme.palette.text.dark
          }}
        />
      </div>

      <div className="flex flex-col gap-3">
        <label className="font-bold">Client Secret</label>
        <input
          type="text"
          value={zohoClientSecret}
          onChange={(e) => setZohoClientSecret(e.target.value)}
          placeholder="Enter the client secret"
          className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          style={{
            borderColor: theme.palette.secondary.v4,
            color: theme.palette.text.dark
          }}
        />
      </div>
      <p className="text-xs">
        You can find the client ID and Secret from <a href="https://api-console.zoho.com/" target="_blank" rel="noreferrer" className="underline">here</a>.
      </p>
      {errorMessage && (
        <div className="mt-4 text-accent-red text-sm">{errorMessage}</div>
      )}
    </div>
  );
}
